export * from "-!../../../../../node_modules/babel-loader/lib/index.js!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./UserPermissionsCard.vue?vue&type=template&id=218ebfe5"


//////////////////
// WEBPACK FOOTER
// ./src/pages/Dashboard/Pages/UserProfileComponents/UserPermissionsCard.vue?vue&type=template&id=218ebfe5
// module id = 2262
// module chunks = 31